import { useIntl } from 'react-intl';

import { TextDocument } from '@sorare/core/src/routing/TextDocument/lazy';

import { InfoLayout } from '#src/components/layouts/InfoLayout.tsx';

const GameRules = () => {
  const { formatMessage } = useIntl();
  return (
    <InfoLayout>
      <TextDocument
        document={formatMessage({
          id: 'GameRules.path',
          defaultMessage: 'GAME_RULES.md',
        })}
        escapeHtml={false}
      />
    </InfoLayout>
  );
};

export default GameRules;
